/**
 * MAP-1587: property generation occasionally failed and then succeeded on the
 * very next click. Both reported occurrences were `POST /ai/extend-metadata`
 * returning a 5xx: one a bare 500, one a 503 with an "OK" status text, which is
 * what a router timeout in front of the app looks like rather than a refusal
 * from the model. Unlike every other heavy AI call this one is synchronous, so
 * it holds the HTTP request open for the whole model round trip and is the one
 * most exposed to that timeout.
 *
 * These statuses say "try again", so a single silent retry turns the reported
 * failure into a slightly slower success. Anything the caller could act on
 * (auth, quota, validation) is deliberately excluded, as is 429: retrying a
 * rate limit immediately only deepens it.
 */
const TRANSIENT_STATUSES = new Set([
  0, // request never completed: network drop, CORS abort, client-side timeout
  408, // Request Timeout
  425, // Too Early
  500, // Internal Server Error
  502, // Bad Gateway
  503, // Service Unavailable
  504, // Gateway Timeout
]);

export function isTransientAiFailure(status: number | undefined | null): boolean {
  return typeof status === 'number' && TRANSIENT_STATUSES.has(status);
}

/** One retry, so a single transient failure costs latency rather than an error. */
export const AI_RETRY_ATTEMPTS = 1;

/** Long enough for a momentary blip to clear, short enough to feel like one slow click. */
export const AI_RETRY_DELAY_MS = 700;
